/**
 * VERANI — Header & Footer interactions
 * Scroll-condense · Menu drawer · Search overlay · Theme toggle · Footer accordion
 */
(function () {
  'use strict';

  var SCHEME_KEY = 'verani-color-scheme';

  function qs(s, c)  { return (c || document).querySelector(s); }
  function qsa(s, c) { return Array.from((c || document).querySelectorAll(s)); }

  // ── Color scheme ──────────────────────────────────────────────────────────
  function getDefault() {
    var el = qs('#vn-header') || qs('[data-default-scheme]');
    return el ? (el.dataset.defaultScheme || 'onyx') : 'onyx';
  }
  function getCurrent() {
    try { return localStorage.getItem(SCHEME_KEY) || getDefault(); } catch (_) { return getDefault(); }
  }
  function applyScheme(s) {
    qsa('[data-vn-themed]').forEach(function (el) { el.setAttribute('data-scheme', s); });
    qsa('[data-vn-scheme]').forEach(function (btn) {
      btn.classList.toggle('is-on', btn.dataset.vnScheme === s);
    });
    qsa('[data-vn-theme-toggle]').forEach(function (btn) {
      var sun  = qs('.vn-ico-sun',  btn);
      var moon = qs('.vn-ico-moon', btn);
      if (sun)  sun.style.display  = s === 'onyx'  ? 'block' : 'none';
      if (moon) moon.style.display = s === 'ivory' ? 'block' : 'none';
    });
  }
  function setScheme(s) {
    try { localStorage.setItem(SCHEME_KEY, s); } catch (_) {}
    applyScheme(s);
  }

  // ── Spacer — keep height in sync with fixed header ───────────────────────
  function initSpacer() {
    var header = qs('.vn-header');
    var spacer = qs('#vn-header-spacer');
    if (!header || !spacer) return;
    if (spacer.classList.contains('vn-no-spacer')) return;
    function sync() {
      var h = header.offsetHeight;
      spacer.style.height = h + 'px';
      document.documentElement.style.setProperty('--vn-header-h', h + 'px');
    }
    sync();
    window.addEventListener('resize', sync, { passive: true });
  }

  // ── Scroll condense ───────────────────────────────────────────────────────
  function initScrollCondense() {
    var header = qs('.vn-header');
    if (!header) return;
    var threshold = parseInt(header.dataset.condenseThreshold || '48', 10);
    function update() { header.classList.toggle('is-condensed', window.scrollY > threshold); }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  // ── Menu drawer ───────────────────────────────────────────────────────────
  function initDrawer() {
    var root = qs('#vn-drawer-root');
    if (!root) return;

    var scrim    = qs('.vn-scrim', root);
    var navItems = qsa('.vn-dnav-item', root);
    var navRows  = qsa('.vn-dnav-row[data-nav-idx]', root);
    var previews = qsa('.vn-preview-img', root);
    var caps     = qsa('.vn-preview-cap-item', root);
    var isOpen   = false;

    function setActive(idx) {
      navItems.forEach(function (it, i) { it.classList.toggle('active', i === idx); });
      previews.forEach(function (img, i) { img.classList.toggle('is-on', i === idx); });
      caps.forEach(function (cap, i)     { cap.classList.toggle('is-on', i === idx); });
    }

    function open() {
      isOpen = true;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (navItems.length) setActive(0);
    }
    function close() {
      isOpen = false;
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    qsa('[data-vn-open-menu]').forEach(function (btn) { btn.addEventListener('click', open); });
    qsa('[data-vn-close-menu]').forEach(function (btn) { btn.addEventListener('click', close); });
    if (scrim) scrim.addEventListener('click', close);

    navItems.forEach(function (item, i) {
      item.addEventListener('mouseenter', function () { setActive(i); });
    });

    if (!navItems.length && navRows.length) {
      var navParent = navRows[0].closest('.vn-dnav');
      if (navParent) {
        navParent.addEventListener('mouseleave', function () {
          navRows.forEach(function (r) { r.classList.remove('dim'); });
        });
      }
      navRows.forEach(function (row, i) {
        row.addEventListener('mouseenter', function () {
          navRows.forEach(function (r, j) { r.classList.toggle('dim', j !== i); });
        });
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) close();
    });
  }

  // ── Search overlay ────────────────────────────────────────────────────────
  function initSearch() {
    var panel = qs('.vn-search');
    if (!panel) return;
    var field = qs('.vn-search-field', panel);

    qsa('[data-vn-search-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var opening = !panel.classList.contains('is-open');
        panel.classList.toggle('is-open', opening);
        if (opening && field) setTimeout(function () { field.focus(); }, 60);
      });
    });
    qsa('[data-vn-search-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { panel.classList.remove('is-open'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') panel.classList.remove('is-open');
    });
  }

  // ── Footer accordion (mobile) ─────────────────────────────────────────────
  function initFooterAccordion() {
    qsa('.vn-sf-accrow').forEach(function (row) {
      var btn = qs('.vn-sf-acchead', row);
      if (!btn) return;
      btn.addEventListener('click', function () {
        var wasOpen = row.classList.contains('is-open');
        qsa('.vn-sf-accrow').forEach(function (r) { r.classList.remove('is-open'); });
        if (!wasOpen) row.classList.add('is-open');
      });
    });
  }

  // ── Appearance buttons ────────────────────────────────────────────────────
  function initAppearance() {
    qsa('[data-vn-scheme]').forEach(function (btn) {
      btn.addEventListener('click', function () { setScheme(btn.dataset.vnScheme); });
    });
    qsa('[data-vn-theme-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setScheme(getCurrent() === 'onyx' ? 'ivory' : 'onyx');
      });
    });
  }

  // ── Init ──────────────────────────────────────────────────────────────────
  function init() {
    applyScheme(getCurrent());
    initSpacer();
    initScrollCondense();
    initDrawer();
    initSearch();
    initFooterAccordion();
    initAppearance();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
